import { Text } from '@medly-components/core';
import { CoralText } from 'components/common/Styled';
import styled from 'styled-components';

export const ZoneTilesHeaderWrapper = styled.div``;

export const HeaderText = styled(Text)`
    color: ${({ theme }) => theme.colors.darkBlue};
`;

export const RegionVersionField = styled(Text)`
    color: ${({ theme }) => theme.colors.grey[700]};
    display: flex;
    gap: 0.8rem;
    align-items: center;
`;

export const UnAssignMapText = styled(CoralText).attrs({ textVariant: 'h4' })`
    cursor: pointer;
`;
